import { useAppActions } from 'reducers/slices/bidRequestSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { saveBidRequest, saveAndOpenBidRequest, loadBidRequest, openBidRequest } = useAppActions();
  const { loading, bidRequest, progress, saving, creating } = useSelector(state => state.bidRequestSlice);

  return {
    saveBidRequest,
    loadBidRequest,
    openBidRequest,
    saveAndOpenBidRequest,
    bidRequest,
    loading,
    creating,
    progress,
    saving,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useBidRequest.js